import { Sparkles } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

export const AiPromptIcon: React.FC = () => <Sparkles className={css.icon} />
